import { ListItemIcon } from "@mui/material";
import React from "react";

import type { SidebarMenuItemIconProps } from "./types";
import { sidebarTheme } from "@/styles/sidebarTheme";

export const SidebarMenuItemIcon: React.FC<SidebarMenuItemIconProps> = ({
  Icon,
  isSelected,
  level = 0,
}) => {
  if (!Icon) return null;

  const isTopLevel = level === 0;

  return (
    <ListItemIcon
      sx={{
        color: isSelected
          ? sidebarTheme.menu.selected.icon
          : isTopLevel
          ? sidebarTheme.menu.normal.iconTopLevel
          : sidebarTheme.menu.normal.iconSubmenu,
        minWidth: isTopLevel ? 40 : 36,
        mr: isTopLevel ? 2 : 1.5,
        fontSize: isTopLevel ? 24 : 20,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Icon fontSize="inherit" color="inherit" />
    </ListItemIcon>
  );
};
